import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/financial-reports/transactions/allowance/$batchId")({
  beforeLoad: () => ({
    breadcrumb: "View Details",
  }),
  component: lazyRouteComponent(() => import("./+BatchDetails")),
});
